import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Spin as AntSpin } from 'antd'
import './Spin.less'

export default class Spin extends PureComponent {
  render() {
    const { className, wrapperClassName } = this.props
    const indicator = (
      <div className='pan-spinner-indicator'>
        <u></u>
        <u></u>
        <u></u>
        <u></u>
        <u></u>
        <u></u>
        <u></u>
      </div>
    )
    const spinProps = {
      indicator,
      className: classNames(className, 'pan-spin'),
      wrapperClassName: classNames(wrapperClassName, 'pan-spin-wrapper'),
    }
    return <AntSpin {...this.props} {...spinProps} />
  }
}

Spin.AntSpin = AntSpin
